import {Component, OnInit} from '@angular/core';
import {UntypedFormGroup, UntypedFormControl, UntypedFormBuilder} from '@angular/forms';
import {AlertService} from 'src/app/services/alert/alert.service';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {UserService} from 'src/app/services/user/user.service';
import {UserPreferencesService} from 'src/app/services/user-preferences/user-preferences.service';
import {ShipmentReviewService} from 'src/app/services/shipment-review/shipment-review.service';
import {takeWhile} from 'rxjs/operators';
import {User} from 'src/app/services/user/user';
import {BehaviorSubject} from 'rxjs';
import AppConstants, * as Constants from '../../shared/common-components/AppConstants';
import {UserPreference} from '../user-preferences/user-preference';
import {PrefItem} from '../user-preferences/pref-item';

@Component({
    selector: 'app-hhg-shipment-review',
    templateUrl: './hhg-shipment-review.component.html',
    styleUrls: ['./hhg-shipment-review.component.css'],
    standalone: false
})
export class HhgShipmentReviewComponent implements OnInit {

  shipmentReviewForm: UntypedFormGroup;
  shipmentReviewList: any = [];
  shipmentReviewListBeforeEditFields: any = [];
  currentUser: User;
  haveRecords = false;
  errorMessage = '';
  shipmentType = 'HHG';
  status = 'All';
  isFromHHGShipment: boolean;
  isFromFRTShipment: boolean;
  frameworkComponents: any;
  private tmssloader;
  orgId: number;
  carrierUser: boolean;
  carrierId: number;
  private observer$ = new BehaviorSubject(true);
  agency_admin = Constants.agency_admin_role;
  agency_user = Constants.agency_user;
  screenName: any;
  userPref: UserPreference;
  userPrefList: PrefItem[];
  statuses: string[] = ['Accepted', 'Accepted with Qualification', 'Booked', 'Cancelled', 'Complete', 'Expired', 'Incomplete', 'Modified',
    'Pending', 'Refused'];
  statusesTsp: string[] = ['Accepted', 'Accepted with Qualification', 'Booked', 'Cancelled', 'Complete', 'Expired', 'Modified',
    'Pending', 'Refused'];
  recent: boolean;

  constructor(private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private loader: LoadingService,
              private route: ActivatedRoute,
              public datePipe: DatePipe,
              private userService: UserService,
              private userPreferencesService: UserPreferencesService,
              private shipmentReviewService: ShipmentReviewService,
              private router: Router) {

  }

  ngOnInit(): void {
    this.tmssloader = this.loader;
    this.userService.getCurrentUserObservable().pipe(takeWhile(() => this.observer$.value)).subscribe(currentUser => {
      this.currentUser = currentUser;
      this.getUserPrefs();
      if (AppConstants.isNotNullCondition(this.currentUser)) {
        if (this.currentUser.roles[0].name === this.agency_admin || this.currentUser.roles[0].name === this.agency_user) {
          this.orgId = this.currentUser.organizationId;
        } else {
          this.orgId = -1;
        }
      } else {
        this.orgId = -1;
      }
      if (this.currentUser.carrierId !== null) {
        this.carrierUser = true;
        this.carrierId = this.currentUser.carrierId;
      } else {
        this.carrierUser = false;
        this.carrierId = -1;
      }
    });
    this.getShipmentReviewList('HHG', 'Recent');
    this.recent = true;
    this.initForm();
  }

  initForm() {
    this.shipmentReviewForm = this.fb.group({
      status: new UntypedFormControl('All'),
    });
  }

  getUserPrefs() {
    const userId = this.currentUser.userSessionEntity.userId;
    const orgId = this.currentUser.userSessionEntity.organizationId;
    const queryScreenName = 'HHGShipments';

    this.userPreferencesService.getUserPrefs(userId, orgId, queryScreenName).subscribe(result => {
      this.userPref = result;
      console.log(this.userPref);
      this.userPrefList = this.userPref.listPrefs;
      this.screenName = this.userPref.screenName;
      console.log(this.screenName);
    }, error => {
      this.alertService.error('Error while retreiving the user preferences');
    });

  }

  // Get the Shipment Review records for a provided shipmentType
  getShipmentReviewList(shipmentType: string, status: string) {
    this.shipmentReviewListBeforeEditFields = [];
    this.shipmentReviewList = [];
    this.tmssloader.show();
    this.shipmentReviewService.getShipmentReviewListByShipmentType(shipmentType, status, this.orgId, this.carrierId)
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(data => {
        if (data) {
          this.shipmentReviewListBeforeEditFields = data;
          this.shipmentReviewList = data;
          console.log(data);
          //this.tmssloader.hide();
          for (const shipmentReviewDetails of this.shipmentReviewListBeforeEditFields) {
            if (shipmentReviewDetails.originCountry === 'UNITED STATES') {
              shipmentReviewDetails.origin = shipmentReviewDetails.originCity + ', '
                + shipmentReviewDetails.originState + '(' + shipmentReviewDetails.originZip + ')';
            }
            if (shipmentReviewDetails.originCountry !== 'UNITED STATES') {
              shipmentReviewDetails.origin = shipmentReviewDetails.originCountry;
            }
            if (shipmentReviewDetails.destContry === 'UNITED STATES') {
              shipmentReviewDetails.destination = shipmentReviewDetails.destCity + ', '
                + shipmentReviewDetails.destState + '(' + shipmentReviewDetails.destZip + ')';
            }
            if (shipmentReviewDetails.destContry !== 'UNITED STATES') {
              shipmentReviewDetails.destination = shipmentReviewDetails.destContry;
            }
            if (null != shipmentReviewDetails.moveDate && shipmentReviewDetails.moveDate.length > 0) {
              shipmentReviewDetails.moveDate = this.datePipe.transform(shipmentReviewDetails.moveDate, 'MM/dd/yyyy');
            }
            if (null != shipmentReviewDetails.actualDeliveryDate && shipmentReviewDetails.actualDeliveryDate.length > 0) {
              shipmentReviewDetails.actualDeliveryDate = this.datePipe.transform(shipmentReviewDetails.actualDeliveryDate, 'MM/dd/yyyy');
            }
            if (null != shipmentReviewDetails.dateSentToSyncada && shipmentReviewDetails.dateSentToSyncada.length > 0) {
              shipmentReviewDetails.dateSentToSyncada = this.datePipe.transform(shipmentReviewDetails.dateSentToSyncada, 'MM/dd/yyyy');
            }
          }
          if (this.shipmentReviewListBeforeEditFields.length > 0) {
            this.haveRecords = true;
            this.errorMessage = '';
          }
          if (this.shipmentReviewListBeforeEditFields.length === 0) {
            this.errorMessage = 'No records found for the search criteria!!!!!! ';
          }
        }
        this.tmssloader.hide();
      }, (error) => {
        this.tmssloader.hide();
        this.alertService.error('There was an error retrieving Shipment Review records');
      });
  }

  statusChange(event) {
    this.status = this.shipmentReviewForm.get('status').value;
    if (this.status == 'Recent') {
      this.getShipmentReviewList('HHG', 'Recent');
    } else {
      this.shipmentReviewList = [];
      this.shipmentReviewListBeforeEditFields.forEach(x => {
        if ((x.bookingStatus == this.status) || (this.status == 'All')) {
          this.shipmentReviewList.push(x);
        }
      });
    }
    
  }

  refreshTableandStatus() {
    this.getShipmentReviewList(this.shipmentType, 'All');
    this.shipmentReviewForm.get('status').setValue('All');
    this.recent = false;
  }
}

